

















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class InputSearch extends Vue {
  @Prop({ default: false }) readonly showOnly!: boolean;
  @Prop({ default: "200px" }) readonly width!: string;

  private showinput = false;
  private value = "";

  mounted() {
    if (this.showOnly) {
      this.togelFocus();
      this.showinput = true;
    }
  }

  public togelFocus() {
    this.$nextTick(() => {
      const inputSearch: any = this.$refs.inputSearch;
      inputSearch.focus();
    });
  }
  public hide() {
    if (!this.value && !this.showOnly) {
      this.showinput = false;
    }
  }
}
